import { render, staticRenderFns } from "./stat.vue?vue&type=template&id=d318fcc2&scoped=true&"
import script from "./stat.vue?vue&type=script&lang=js&"
export * from "./stat.vue?vue&type=script&lang=js&"
import style0 from "./stat.vue?vue&type=style&index=0&id=d318fcc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d318fcc2",
  null
  
)

export default component.exports